import { colorPalette } from "config/theme";

export const AWAY_COLOR = colorPalette.away;
export const HOME_COLOR = colorPalette.home;

export const getTeamColors = (status: any) => {
  const pickFirstColor = (si?: string | null) => {
    if (!si || typeof si !== "string") return undefined;
    const first = si
      .split(",")
      .map((s) => s.trim())
      .find(Boolean);
    return first && first.length > 0 ? first : undefined;
  };

  const homeFromKit =
    pickFirstColor(status?.T1?.kit?.si) ?? pickFirstColor(status?.t1?.kit?.si);
  const awayFromKit =
    pickFirstColor(status?.T2?.kit?.si) ?? pickFirstColor(status?.t2?.kit?.si);

  const home =
    homeFromKit ??
    (status?.t1c && String(status.t1c).trim()) ??
    (status?.T1c && String(status.T1c).trim()) ??
    HOME_COLOR;

  const away =
    awayFromKit ??
    (status?.t2c && String(status.t2c).trim()) ??
    (status?.T2c && String(status.T2c).trim()) ??
    AWAY_COLOR;

  return { home, away };
};
